
export enum WeatherSensor {
  temperature = 'temperature',
  humidity = 'humidity'
}
